import { QuestionCircle } from '@styled-icons/fa-solid';
import { useMemo, useState } from 'react';
import { Form, Modal, OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';
import ControlsGoodsExportLinks from '../../ControlsGoodsExportLinks';
import ControlsGoodsInformationLinks from '../../ControlsGoodsInformationLinks';
import { useStepper } from '../../Stepper/index';
import '../epo.css';

/** Stable Playwright selectors for controlled-good category checkboxes (labels must match API/category strings). */
const COG_CATEGORY_CHECKBOX_TEST_ID = {
  'High-Risk Food of Non-Animal Origin (HRFNAO)': 'hrfnao-checkbox',
  'Fishery Products - Fish, Molluscs or Crustaceans': 'fisheryProducts-checkbox',
  'Products Of Animal Origin (POAO)': 'poao-checkbox',
  'Military Goods - Restricted or Dual-Use Goods': 'militaryGoods-checkbox',
  'Endangered Species (CITES)': 'cites-checkbox',
  'Excise Goods - Wine, Beer, Spirits or Tobacco': 'exciseGoods-checkbox',
  'Plants and Plant Products': 'plants-checkbox',
  'Plants and Plant Products (Medium or High Risk)': 'plants-checkbox',
};

const cogCategoryCheckboxTestId = (categoryLabel) => COG_CATEGORY_CHECKBOX_TEST_ID[categoryLabel];

const CogModal = ({ onSave, onCancel, show }) => {
  const { localData, setDataByKey } = useStepper();
  const [confirmedNoCG, setConfirmNoCG] = useState('');

  const controlledGoods = useMemo(() => {
    return localData.categoryOptions.filter((category) => category.controlled);
  }, [localData.categoryOptions]);

  const checkedCategories = useMemo(() => {
    return localData.categoryOptions.filter((category) => category.checked);
  }, [localData.categoryOptions]);

  const setCategoryOptionCheckedById = (id, value) => {
    if (value === true) {
      setConfirmNoCG('CG');
    }

    const newCategoryOptions = (previous) => {
      const idx = previous.findIndex((category) => category.id === id);
      const updated = previous[idx];
      const result = [...previous.slice(0, idx), { ...updated, checked: value }, ...previous.slice(idx + 1)];
      return [...result];
    };

    setDataByKey('categoryOptions', newCategoryOptions(localData.categoryOptions));
  };

  const handleSaveSelection = () => {
    onSave(
      localData.categoryOptions.filter((category) => category.checked),
      confirmedNoCG
    );
  };

  const handleChange = (e) => {
    if (e === 'CG') {
      setConfirmNoCG('CG');
    }
    if (e === 'NCG') {
      setConfirmNoCG('NCG');
      setDataByKey('categoryOptions', localData.categoryOptionsDefault);
    }
  };

  return (
    <Modal onHide={onCancel} show={show} centered size="md" contentClassName="editModal" animation={false}>
      <Modal.Header>
        <Modal.Title>
          <span className="mx-4">Category of Goods</span>
        </Modal.Title>{' '}
        <OverlayTrigger
          placement="left"
          trigger={['click']}
          rootClose
          overlay={
            <Popover style={{ width: '100%', maxWidth: '25rem' }}>
              <PopoverContent>
                {(localData.movementType === 'Import' && <ControlsGoodsInformationLinks />) || (
                  <ControlsGoodsExportLinks />
                )}
              </PopoverContent>
            </Popover>
          }
        >
          <button type="button" style={{ paddingLeft: '0' }} className="invoice-add-btn green-text">
            <QuestionCircle width="1.4rem" height="1.7rem" />
          </button>
        </OverlayTrigger>
        <button type="button" class="btn-close" aria-label="Close" onClick={onCancel} />
      </Modal.Header>
      <Form onSubmit={null} className="flex-grow-1 d-flex flex-column overflow-auto">
        <input type="hidden" name="id" value={'Modal For Now'} />
        <Modal.Body className="flex-grow-1 d-flex flex-column pt-0">
          <section className="d-flex w-100 ps-4">
            <div className="text-eoriblue mt-4">
              <div className="flex-grow-1" />

              <div className="d-flex flex-column pb-4 mt-2">
                <label className="d-inline-flex align-items-center gap-2 my-2">
                  <input
                    type="radio"
                    data-testid="controlledGoods-radio"
                    checked={confirmedNoCG == 'CG'}
                    onChange={() => handleChange('CG')}
                  />
                  <span>Controlled Goods</span>
                </label>
                {controlledGoods.map((category) => (
                  <div key={category.id} className="d-flex flex-column ml-2 mt-2">
                    <label
                      className="d-flex align-items-center mb-2 gap-1"
                      style={{ fontSize: '1rem', cursor: 'pointer' }}
                    >
                      <input
                        type="checkbox"
                        data-testid={cogCategoryCheckboxTestId(category.category)}
                        checked={category.checked ?? false}
                        disabled={confirmedNoCG !== 'CG'}
                        onChange={() => setCategoryOptionCheckedById(category.id, !category.checked)}
                      />
                      <span>{category.category}</span>
                    </label>
                  </div>
                ))}
                <label className="d-inline-flex align-items-center gap-2 my-2">
                  <input
                    type="radio"
                    data-testid="nonControlledGoods-radio"
                    checked={confirmedNoCG == 'NCG'}
                    onChange={() => handleChange('NCG')}
                  />
                  <span>Non-Controlled Goods</span>
                </label>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer
          class="d-flex pb-2 pt-1 px-3 gap-3 border-top bg-light align-items-center"
          style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
        >
          <div className="flex-grow-1" />
          <button
            type="button"
            className="blue-button-teams cancel-button"
            onClick={onCancel}
            style={{ display: 'flex', borderRadius: '10px' }}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={confirmedNoCG == 'CG' && checkedCategories.length === 0}
            onClick={handleSaveSelection}
            className="blue-button-teams green-btn"
            style={{ borderRadius: '10px' }}
          >
            Save
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default CogModal;
